/* AXYRON theme JS — no dependencies. ~6 KB minified.
   Modules: header, drawers, search, reveal, lazy images, series scroller,
   accordion, product form, cart (AJAX), page transitions, newsletter. */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = (cents) => {
    const fmt = (window.AXYRON && window.AXYRON.money) || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    const withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, withComma).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  };

  /* ---------- Header: sticky state + hide on scroll down ---------- */
  const header = $('[data-header]');
  if (header) {
    let last = 0, ticking = false;
    const solid = header.hasAttribute('data-solid');
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 24 || solid);
      if (y > 400 && y > last + 6) header.classList.add('is-hidden');
      else if (y < last - 6 || y < 200) header.classList.remove('is-hidden');
      last = y; ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
    onScroll();
  }

  /* ---------- Drawers & overlays ---------- */
  const overlay = $('[data-overlay]');
  let openEl = null;
  function openDrawer(id) {
    const el = document.getElementById(id); if (!el) return;
    closeAll();
    el.classList.add('is-open'); el.removeAttribute('aria-hidden');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    openEl = el;
    const focusable = el.querySelector('input, button, a'); focusable && setTimeout(() => focusable.focus(), 350);
  }
  function closeAll() {
    $$('.drawer.is-open, .search-modal.is-open').forEach(el => { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); });
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    openEl = null;
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]'); if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]') || e.target === overlay) closeAll();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* ---------- Predictive search ---------- */
  const searchInput = $('[data-search-input]');
  const searchResults = $('[data-search-results]');
  if (searchInput && searchResults && window.AXYRON) {
    let t;
    searchInput.addEventListener('input', () => {
      clearTimeout(t);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const r = await fetch(`${window.AXYRON.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`);
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('#shopify-section-predictive-search');
          searchResults.innerHTML = inner ? inner.innerHTML : '';
        } catch (err) { /* silent */ }
      }, 220);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  const revealEls = $$('.reveal, .reveal-lines');
  if ('IntersectionObserver' in window && !reduced && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    revealEls.forEach(el => io.observe(el));
  } else revealEls.forEach(el => el.classList.add('is-in'));

  /* ---------- Lazy image fade ---------- */
  $$('img.img-lazy').forEach(img => {
    if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
    else img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
  });

  /* ---------- Signature series scroller ---------- */
  $$('[data-series]').forEach(section => {
    const track = $('[data-series-track]', section);
    const prev = $('[data-series-prev]', section);
    const next = $('[data-series-next]', section);
    const bar = $('[data-series-bar]', section);
    if (!track) return;
    const step = () => { const item = track.querySelector('.series__item'); return item ? item.getBoundingClientRect().width + 24 : 400; };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    const update = () => {
      if (!bar) return;
      const max = track.scrollWidth - track.clientWidth;
      const ratio = track.clientWidth / track.scrollWidth;
      bar.style.width = `${Math.max(ratio * 100, 8)}%`;
      bar.style.transform = `translateX(${max ? (track.scrollLeft / max) * (100 / ratio - 100) : 0}%)`;
    };
    track.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
    // Drag to scroll (desktop)
    let down = false, startX = 0, startL = 0, moved = false;
    track.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; startX = e.clientX; startL = track.scrollLeft; track.classList.add('is-dragging'); });
    window.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - startX; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = startL - dx; });
    window.addEventListener('pointerup', () => { if (!down) return; down = false; track.classList.remove('is-dragging'); });
    track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });

  /* ---------- Accordion ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.accordion__trigger'); if (!btn) return;
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    const open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    if (panel) open ? panel.removeAttribute('data-open') : panel.setAttribute('data-open', '');
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-change]'); if (!b) return;
    const input = b.parentElement.querySelector('input'); if (!input) return;
    const v = Math.max(parseInt(input.min || 1, 10), (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-change'), 10));
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product form: variants + add to cart ---------- */
  $$('[data-product-form]').forEach(form => {
    const json = $('[data-product-json]', form.closest('[data-product]') || document);
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const idInput = $('[name="id"]', form);
    const priceEl = $('[data-price]', form.closest('[data-product]'));
    const submit = $('[data-add-to-cart]', form);
    const submitText = $('[data-add-to-cart-text]', form);
    const S = window.AXYRON.strings;
    const selected = () => $$('[data-option-index]', form).map(g => { const c = g.querySelector('input:checked'); return c ? c.value : (g.value || null); });
    const update = () => {
      const opts = selected();
      const v = product.variants.find(v => v.options.every((o, i) => o === opts[i]));
      if (v) {
        idInput.value = v.id;
        if (priceEl) {
          priceEl.innerHTML = v.compare_at_price > v.price
            ? `<span class="price price--sale"><span class="price__current">${money(v.price)}</span><s class="price__compare">${money(v.compare_at_price)}</s></span>`
            : `<span class="price"><span class="price__current">${money(v.price)}</span></span>`;
        }
        submit.disabled = !v.available;
        submitText.textContent = v.available ? S.addToCart : S.soldOut;
        // update URL
        const u = new URL(location); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      } else { submit.disabled = true; submitText.textContent = S.unavailable; }
      // mark unavailable options for the first option group only (cheap, avoids combinatorics)
      $$('[data-option-index="0"] .variant__option', form).forEach(opt => {
        const val = opt.querySelector('input').value;
        const any = product.variants.some(v => v.option1 === val && v.available);
        opt.classList.toggle('is-unavailable', !any);
      });
    };
    form.addEventListener('change', (e) => { if (e.target.matches('input[type=radio], select[data-option-index]')) update(); });
    update();
    form.addEventListener('submit', async (e) => {
      if (form.hasAttribute('data-no-ajax')) return;
      e.preventDefault();
      submit.disabled = true; submitText.textContent = S.adding;
      try {
        const fd = new FormData(form);
        const r = await fetch(window.AXYRON.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
        if (!r.ok) throw new Error();
        submitText.textContent = S.added;
        await refreshCart(true);
        setTimeout(() => { submitText.textContent = S.addToCart; submit.disabled = false; }, 1200);
      } catch (err) { submitText.textContent = S.addToCart; submit.disabled = false; }
    });
  });

  /* ---------- Quick add (product cards) ---------- */
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('[data-quick-add]'); if (!f) return;
    e.preventDefault();
    const b = f.querySelector('button'); const orig = b.textContent; b.disabled = true; b.textContent = window.AXYRON.strings.adding;
    try {
      const r = await fetch(window.AXYRON.routes.cartAdd + '.js', { method: 'POST', body: new FormData(f), headers: { 'Accept': 'application/json' } });
      if (!r.ok) throw new Error();
      await refreshCart(true);
    } catch (err) { /* noop */ }
    b.textContent = orig; b.disabled = false;
  });

  /* ---------- Cart drawer: fetch + render section ---------- */
  async function refreshCart(open) {
    const drawer = document.getElementById('CartDrawer');
    try {
      const r = await fetch(`${window.AXYRON.routes.cart}?section_id=cart-drawer`);
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer-inner]');
      const cur = drawer && drawer.querySelector('[data-cart-drawer-inner]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      const count = doc.querySelector('[data-cart-count-src]');
      if (count) $$('[data-cart-count]').forEach(el => { el.textContent = count.textContent; el.setAttribute('data-count', count.textContent.trim()); });
    } catch (err) { /* noop */ }
    if (open && drawer) openDrawer('CartDrawer');
  }
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-line-qty]'); if (!input) return;
    await changeLine(input.getAttribute('data-line-key'), parseInt(input.value, 10));
  });
  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-line-remove]'); if (!rm) return;
    e.preventDefault(); await changeLine(rm.getAttribute('data-line-key'), 0);
  });
  async function changeLine(key, qty) {
    try {
      await fetch(window.AXYRON.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
      if (document.body.classList.contains('template-cart')) location.reload(); else await refreshCart(false);
    } catch (err) { /* noop */ }
  }

  /* ---------- Page transitions (progressive) ---------- */
  if (!reduced) {
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href]'); if (!a) return;
      if (a.target === '_blank' || a.hasAttribute('download') || a.href.startsWith('mailto:') || a.href.startsWith('tel:') || a.hash && a.pathname === location.pathname || e.metaKey || e.ctrlKey || e.shiftKey) return;
      if (new URL(a.href).origin !== location.origin) return;
      if (a.closest('[data-no-transition]')) return;
      e.preventDefault(); document.body.classList.add('is-leaving');
      setTimeout(() => { location.href = a.href; }, 260);
    });
    window.addEventListener('pageshow', (e) => { if (e.persisted) document.body.classList.remove('is-leaving'); });
  }

  /* ---------- Collection: sort + filter form auto-submit ---------- */
  const sortSel = $('[data-sort-by]');
  if (sortSel) sortSel.addEventListener('change', () => { const u = new URL(location); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); location.href = u; });
  const filterForm = $('[data-filter-form]');
  if (filterForm) {
    let ft;
    filterForm.addEventListener('change', () => { clearTimeout(ft); ft = setTimeout(() => filterForm.requestSubmit ? filterForm.requestSubmit() : filterForm.submit(), 350); });
  }

  /* ---------- Mobile gallery dots ---------- */
  $$('[data-gallery]').forEach(g => {
    const dots = $$('[data-gallery-dot]', g.parentElement);
    if (!dots.length) return;
    g.addEventListener('scroll', () => {
      const i = Math.round(g.scrollLeft / (g.firstElementChild.getBoundingClientRect().width + 4));
      dots.forEach((d, j) => j === i ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current'));
    }, { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', () => g.children[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' })));
  });
})();
